export const warning = [
	'40 40',
	`
<path d="M21.25 13.75H18.75V27.5H21.25V13.75Z" fill="#ED3138"/>
<path d="M21.25 30H18.75V32.5H21.25V30Z" fill="#ED3138"/>
<path d="M21.4073 1.25H18.5927L1.25 34.7792V38.75H38.75V34.7792L21.4073 1.25ZM36.25 36.25H3.75V35.3874L20 3.97078L36.25 35.3874V36.25Z" fill="#ED3138"/>
  `,
];
